
export function formatNotificationTime(
  createdAt: number,
  t: NotificationTranslations,
  locale: string
): string {
  const diff = Date.now() - createdAt;
  const minutes = Math.floor(diff / 60_000);
  const hours = Math.floor(diff / 3_600_000);

  if (minutes < 1) return t.justNow;
  if (minutes < 60) return t.minutesAgo.replace("{{n}}", String(minutes));
  if (hours < 24) return t.hoursAgo.replace("{{n}}", String(hours));

  const date = new Date(createdAt);
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === yesterday.toDateString()) return t.yesterday;

  return date.toLocaleDateString(locale === "fr" ? "fr-FR" : "en-US", {
    day: "numeric",
    month: "short",
  });
}
